module.exports = __webpack_public_path__ + "92e68703606024a16809bc947841964b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/SOLO.jpg
// module id = 1294
// module chunks = 0